import { useWatch } from "react-hook-form";
import type { CSSObjectWithLabel } from "react-select";

import PackingListSelect from "@RequestFormV2/sections/PackingList/components/shared/PackingListSelect";
import { classNames } from "helpers/commonHelpers";
import { getPackingListFieldPath } from "@RequestFormV2/sections/PackingList/utils/fieldPaths";
import { isTotalWeightUnit } from "@RequestFormV2/sections/PackingList/utils/packingListCalculations";

type WeightUnitSelectProps = {
  index: number;
  options: { label: string; value: string }[];
  onChange: () => void;
};

const weightUnitSelectStyles = {
  valueContainer: (base: CSSObjectWithLabel) => ({
    ...base,
    overflow: "visible",
    flexWrap: "nowrap" as const,
  }),
  singleValue: (base: CSSObjectWithLabel) => ({
    ...base,
    position: "static" as const,
    transform: "none",
    maxWidth: "none",
    overflow: "visible",
    textOverflow: "clip",
  }),
  menuPortal: (base: CSSObjectWithLabel) => ({
    ...base,
    maxWidth: 130,
    left: (base.left as number) + (base.minWidth as number),
    transform: "translateX(-100%)",
  }),
  option: (base: CSSObjectWithLabel) => ({
    ...base,
    textAlign: "right" as const,
  }),
};

export default function WeightUnitSelect({ index, options, onChange }: WeightUnitSelectProps) {
  const wUnit = useWatch({ name: getPackingListFieldPath(index, "w_unit") });
  const isTotal = isTotalWeightUnit(wUnit);

  return (
    <div
      className={classNames("rfv2-packing-list-table__weight-unit", {
        "rfv2-packing-list-table__weight-unit--total": isTotal,
        "rfv2-packing-list-table__weight-unit--piece": !isTotal,
      })}
    >
      <PackingListSelect
        isSearchable={false}
        name={getPackingListFieldPath(index, "w_unit")}
        options={options}
        styles={weightUnitSelectStyles}
        onChange={onChange}
      />
    </div>
  );
}
